import { render, staticRenderFns } from "./linkagecenter4.vue?vue&type=template&id=3a7e44fd"
import script from "./linkagecenter4.vue?vue&type=script&lang=js"
export * from "./linkagecenter4.vue?vue&type=script&lang=js"
import style0 from "./linkagecenter4.vue?vue&type=style&index=0&id=3a7e44fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports